export const DEFAULT_TESTIMONIAL_PROMPT = 'In a sentence or two, what was it like working with us, and what changed for you?';
export const TESTIMONIAL_PROMPT_MAX = 600;

export function testimonialPrompt(value: string | null | undefined): string {
  return value?.trim() || DEFAULT_TESTIMONIAL_PROMPT;
}

export function testimonialMediaAdminLink(key: string): string {
  return `/api/admin/sso/media?next=${encodeURIComponent(`/admin?testimonial_key=${encodeURIComponent(key)}`)}`;
}

export function testimonialPermissionLabel(permission: number | null | undefined): string {
  if (permission === 1) return 'Okay to share';
  if (permission === 0) return 'Private feedback';
  return 'Sharing permission not recorded';
}
